import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'PaymentStat',
  props: {
    payments: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isShow: false,
      tileRight: 0
    }
  },
  computed:{
    paymentsComp() {      
      if (this.payments) {
        const { paymentTypes } = this.$store.state.sharedData
        const result = Object.keys(paymentTypes)
        .map(key => ({
          name: paymentTypes[key].title,
          value: this.payments[key] ?? 0
        }))
        return result
      }
      return []
    },
    commonSumm() {
      if (!this.payments) {
        return 0
      }
      if (this.payments.total) {
        return this.payments.total
      }
      const result = this.paymentsComp
        .reduce((acc, paymentObj) => {
          return acc + paymentObj.value
        }, 0)
      return result
    }
    
  },
  mounted() {
    window.addEventListener('click', this.onClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.onClickOutside)
  },
  methods: {
    numberWithSeparator,

    onClickOutside(e) {
      if (this.$refs['payment-stat'].contains(e.target)) {
        return
      }
      this.isShow = false
    },
    openModal() {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.$nextTick(() => {
          const proceedsAmountEl = this.$refs['proceeds-amount']
          const proceedsAmountWidth = proceedsAmountEl.getBoundingClientRect().width
          /**
           * 14 - с учетом paddings и отступов
           */
          this.tileRight = proceedsAmountWidth / 2 + 14 - 5
        })
      }
      
    }
  }
}